import {
  useExecutiveReportFields,
  buildPresentation,
} from '@features/executive-report/subdomains/cpg';
import { presentationToFile } from '@features/powerpoint';
import {
  Campaign,
  CpgReportsParams,
  GetCampaignParams,
} from '@features/campaigns';
import { useCurrentUser } from '@features/users';
import { stringify } from 'qs';
import { useNavigate } from 'react-router-dom';
import { ExecutiveReportDownloadButton } from './ExecutiveReportDownload';
import { clientDefaultValues } from '@features/executive-report/subdomains/cpg';

type CpgExecutiveReportDownloadProps = {
  campaignId: Campaign['id'];
  reportParams: Omit<CpgReportsParams, 'campaignId'>;
  campaignParams: GetCampaignParams;
};

export const CpgExecutiveReportDownload = ({
  campaignId,
  campaignParams,
  reportParams,
}: CpgExecutiveReportDownloadProps) => {
  const navigate = useNavigate();

  const { role: userRole } = useCurrentUser();
  const { data, loading } = useExecutiveReportFields({
    campaignParams: { ...campaignParams, id: campaignId },
    reportParams,
  });

  const onClickHandler = () => {
    if (userRole === 'user') {
      if (!data) throw new Error('Missing data for presentation');

      const presentation = buildPresentation({
        ...data,
        brandLogo: null,
        customFields: clientDefaultValues(data.campaign.name),
      });

      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/cpg/${campaignId}/executive-report?${stringify({
          ...campaignParams,
          ...reportParams,
        })}`
      );
    }
  };

  return (
    <ExecutiveReportDownloadButton
      disabled={!data}
      loading={loading}
      onClickHandler={onClickHandler}
    />
  );
};
